import { AppUiUploadMode } from '@omni/interfaces/app-ui/record.interface';

type Translate = (key: string, params?: Record<string, unknown>) => string;

/** `[by number, before it has one]` for each outcome. */
const MESSAGES: Record<
  AppUiUploadMode,
  Record<'done' | 'refused', [string, string]>
> = {
  draft: {
    done: ['OC_SAVED_AS', 'OC_SAVED'],
    refused: ['OC_SAVE_REFUSED_AS', 'OC_SAVE_REFUSED'],
  },
  submit: {
    done: ['OC_SUBMITTED_AS', 'OC_SUBMITTED'],
    refused: ['OC_SUBMIT_REFUSED_AS', 'OC_SUBMIT_REFUSED'],
  },
  scrap: {
    done: ['OC_SCRAPPED_AS', 'OC_SCRAPPED'],
    refused: ['OC_SCRAP_REFUSED_AS', 'OC_SCRAP_REFUSED'],
  },
};

/**
 * What the rep reads once an order is saved, submitted or scrapped, or refused (`reason` set): the
 * same words online and offline, naming the order by its number once it has one. No word about the
 * device, the sync or the server.
 */
export function orderMessage(
  translate: Translate,
  mode: AppUiUploadMode,
  orderNumber: string | null | undefined,
  reason: string | null = null,
): string {
  const [named, unnamed] = MESSAGES[mode][reason === null ? 'done' : 'refused'];
  const why = reason === null ? {} : { reason };
  return orderNumber
    ? translate(named, {
        name: translate('OC_ORDER_NAMED', { orderNumber }),
        ...why,
      })
    : translate(unnamed, reason === null ? undefined : why);
}
